import { CardContent, CardContentWithoutEK } from '@src/components/Editor/types'
import { createStandardAction } from 'typesafe-actions'

export const AF_SEND_HIDDEN_CARDS = 'AF_SEND_HIDDEN_CARDS'
export const AF_SEND_NEW_CARDS = 'AF_SEND_NEW_CARDS'

export interface NewCardsPayload {
  newCards: CardContent[]
  gatedCards: CardContent[]
}

export const sendHiddenCards = createStandardAction(AF_SEND_HIDDEN_CARDS)<
  Array<CardContent | CardContentWithoutEK>
>()
export const sendNewCards = createStandardAction(AF_SEND_NEW_CARDS)<NewCardsPayload>()



// WEBPACK FOOTER //
// ./src/state/analytics/actions.ts